'use client';

import { FaRegHeart, FaHeart } from 'react-icons/fa6';

import { useState } from 'react';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import axios from '@/lib/axios';
import { toast } from 'react-toastify';
import { pushToDataLayer } from '@/features/gtm/gtmUtils';
import { useAuth } from '@/features/authentication/hooks/auth';
import { usePathname, useRouter } from 'next/navigation';

const ProductDetailsWishlist = ({
  product,
}: {
  product: { id: string; is_wishlisted: any; price: string };
}) => {
  const { user } = useAuth();
  const pathname = usePathname();
  const router = useRouter();
  const { data: wishlists, mutate } = useFetcherCSR(
    user && `/api/v2/wishlists`
  );
  const includeWishlist = wishlists?.data?.some(
    (item: any) => item?.product?.id === product?.id
  );

  const [isWishlist, setIsWishlist] = useState(includeWishlist || false);

  const handleAddToWishList = async () => {
    if (!user) router.push(`/login?redirect=${pathname}`);

    try {
      const res = await axios.get(
        `/api/v2/wishlists-add-product?product_id=${product?.id}`
      );
      if (res.status === 200) {
        toast.success(res?.data?.message);
        mutate();
        setIsWishlist(true);
        pushToDataLayer('add_to_wishlist', {
          ecommerce: {
            member_id: user?.data?.id,
            item_id: product?.id,
            // item: product,
            value: product?.price,
            currency: 'BDT',
          },
        });
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveWishList = async () => {
    try {
      const res = await axios.get(
        `/api/v2/wishlists-remove-product?product_id=${product?.id}`
      );

      if (res.status === 200) {
        toast.error(res?.data?.message);
        mutate();
        setIsWishlist(false);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <button
        onClick={isWishlist ? handleRemoveWishList : handleAddToWishList}
        className="product-details__fav-btn border-0"
        aria-label="Toggle Wishlist"
      >
        {isWishlist ? (
          <FaHeart style={{ color: '#e5456d' }} className="text-badge" />
        ) : (
          <FaRegHeart style={{ color: 'gray' }} />
        )}
      </button>
    </>
  );
};

export default ProductDetailsWishlist;
